import _ from 'lodash'

export default {
    install: (app, options) => {
        app.provide('lodash', _)
    }
  }